// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg_aws[data-v-d266274c]{background-size:cover;background-position:bottom;background-image:url(/img/productos/bg_aws.png)!important}.my_divider[data-v-d266274c]{border:3px solid;border-radius:2px;max-width:5rem;width:40px}.big-plus[data-v-d266274c]{font-size:84px!important}", ""]);
// Exports
module.exports = exports;
